/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCalendarCode = createReactComponent("calendar-code", "IconCalendarCode", [
  [
    "path",
    {
      d: "M11.5 21h-5.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6",
      key: "svg-0"
    }
  ],
  ["path", { d: "M16 3v4", key: "svg-1" }],
  ["path", { d: "M8 3v4", key: "svg-2" }],
  ["path", { d: "M4 11h16", key: "svg-3" }],
  ["path", { d: "M20 21l2 -2l-2 -2", key: "svg-4" }],
  ["path", { d: "M17 17l-2 2l2 2", key: "svg-5" }]
]);

export { IconCalendarCode as default };
//# sourceMappingURL=IconCalendarCode.js.map
